import axios from 'axios';

export const consultaTurmaPorIdService = async ({ idTurma, urlBase, token, matricula, periodo }) => {
  const { data } = await axios.get(`${urlBase}/turmas/${idTurma}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    params: {
      matricula,
      periodo,
    },
  });

  return data;
};
